import { render, staticRenderFns } from "./singleC.vue?vue&type=template&id=0c3bea1b&"
import script from "./singleC.vue?vue&type=script&lang=js&"
export * from "./singleC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports